// extracted by mini-css-extract-plugin
module.exports = {"winning-bet":"styles_winning-bet__1FlaA","fadeOutUp":"styles_fadeOutUp__2c38P","winning-animation":"styles_winning-animation__2H22Z","number":"styles_number__JZaN1"};